import { FILTER_SHOW_ALL } from '../constants/filtering';
import { SET_POST_TYPE_FILTER, SET_CATEGORY_FILTER } from '../actions/set-filter';
import { RESET_POST_TYPE_FILTER, RESET_CATEGORY_FILTER } from '../actions/reset-filter';

export const filtering = (state = { postType: FILTER_SHOW_ALL, categorySlug: '' }, action = {}) => {
  switch (action.type) {
    case SET_POST_TYPE_FILTER:
      return { ...state, postType: action.payload };
    case SET_CATEGORY_FILTER:
      return { ...state, categorySlug: action.payload };
    case RESET_POST_TYPE_FILTER:
      return { ...state, postType: FILTER_SHOW_ALL };
    case RESET_CATEGORY_FILTER:
      return { ...state, categorySlug: '' };
    default:
      return state;
  }
};
